import { SvgProvider as BaseSvgProvider } from "@netlify/ui";
import React from "react";
import IconCaretDown from "../images/icons/icon-caret-down.svg?react";
import IconCheckmark from "../images/icons/icon-checkmark.svg?react";
import IconClose from "../images/icons/icon-close.svg?react";
import IconCopyClipboard from "../images/icons/icon-copy-clipboard.svg?react";
import IconDelete from "../images/icons/icon-delete.svg?react";
import IconEyeClosed from "../images/icons/icon-eye-closed.svg?react";
import IconEyeOpen from "../images/icons/icon-eye-open.svg?react";
import IconGear from "../images/icons/icon-gear.svg?react";
import IconInfoRound from "../images/icons/icon-info-round.svg?react";
import IconStatusCheckmark from "../images/icons/icon-status-checkmark.svg?react";
import IconSuccess from "../images/icons/icon-success.svg?react";
import IconWarningRound from "../images/icons/icon-warning-round.svg?react";
import IconWarningTriangle from "../images/icons/icon-warning-triangle.svg?react";

export enum IconNameToPath {
  "caret-down" = "icons/icon-caret-down",
  "checkmark" = "inline/icon-checkmark",
  "close" = "inline/icon-close",
  "copy-clipboard" = "inline/icon-copy-clipboard",
  "delete" = "inline/icon-delete",
  "eye-closed" = "icons/icon-eye-closed",
  "eye-open" = "icons/icon-eye-open",
  "gear" = "icons/icon-gear",
  "info-round" = "icons/icon-info-round",
  "status-checkmark" = "inline/icon-status-checkmark",
  "success" = "inline/icon-success",
  "warning-round" = "icons/icon-warning-round",
  "warning-triangle" = "icons/icon-warning-triangle",
}

export type IconName = keyof typeof IconNameToPath;

export type IconPath = IconNameToPath[keyof IconNameToPath];

export type SvgProviderProps = {
  children: React.ReactNode;
  importSvg: (path?: IconPath) => Promise<{
    ReactComponent: React.ElementType<React.SVGProps<SVGSVGElement>>;
  }>;
};

export const SvgProvider = (props: SvgProviderProps) => (
  <BaseSvgProvider {...props} />
);

export const defaultImportSvg: SvgProviderProps["importSvg"] = async (
  iconPath,
) => {
  // XXX(ndhoule): I'd prefer to dynamically import these files, but I can't get it working in
  // vite/svgr; instead, this translates icon names/paths that would be used for dynamic imports to
  // their corresponding (static) import
  switch (iconPath) {
    case "icons/icon-caret-down":
      return Promise.resolve({ ReactComponent: IconCaretDown });
    case "inline/icon-copy-clipboard":
      return Promise.resolve({ ReactComponent: IconCopyClipboard });
    case "inline/icon-close":
      return Promise.resolve({ ReactComponent: IconClose });
    case "inline/icon-delete":
      return Promise.resolve({ ReactComponent: IconDelete });
    case "icons/icon-eye-closed":
      return Promise.resolve({ ReactComponent: IconEyeClosed });
    case "icons/icon-eye-open":
      return Promise.resolve({ ReactComponent: IconEyeOpen });
    case "icons/icon-gear":
      return Promise.resolve({ ReactComponent: IconGear });
    case "icons/icon-info-round":
      return Promise.resolve({ ReactComponent: IconInfoRound });
    case "inline/icon-checkmark":
      return Promise.resolve({ ReactComponent: IconCheckmark });
    case "inline/icon-status-checkmark":
      return Promise.resolve({ ReactComponent: IconStatusCheckmark });
    case "inline/icon-success":
      return Promise.resolve({ ReactComponent: IconSuccess });
    case "icons/icon-warning-round":
      return Promise.resolve({ ReactComponent: IconWarningRound });
    case "icons/icon-warning-triangle":
      return Promise.resolve({ ReactComponent: IconWarningTriangle });
    case undefined:
    default:
      throw new Error(
        `Unknown/unsupported icon: ${(iconPath ?? "<unknown>").toString()}`,
      );
  }
};
